import deepFreeze from 'deep-freeze-strict'

/**
 * 快速制作验证规则
 * https://github.com/yiminghe/async-validator
 * @param {*} message
 * @param {*} type
 * @param {*} trigger
 * @param {*} required
 *
 string: Must be of type string. This is the default type.
 number: Must be of type number.
 boolean: Must be of type boolean.
 method: Must be of type function.
 regexp: Must be an instance of RegExp or a string that does not generate an exception when creating a new RegExp.
 integer: Must be of type number and an integer.
 float: Must be of type number and a floating point number.
 array: Must be an array as determined by Array.isArray.
 object: Must be of type object and not Array.isArray.
 enum: Value must exist in the enum.
 date: Value must be valid as determined by Date
 url: Must be of type url.
 hex: Must be of type hex.
 email: Must be of type email.
 *
 * import Schema from 'async-validator'
 * Schema.pattern.email
 */

/**
 * 转换为数字
 * @param value
 * @returns {string|number}
 */
function transformNumber (value) {
  return typeof value === 'string' ? value : Number(value.trim())
}

const rules = deepFreeze({
  id: {
    type: 'integer',
    min: 1,
    transform: transformNumber,
  },
  phone: {
    type: 'integer',
    min: '12999999999',
    max: '19999999999',
    transform: transformNumber,
  },
})

export default {
  rules,
  transformNumber,
}
